import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule as MatMenuModule } from '@angular/material/menu';

import { HeaderComponent } from './components/header/header.component';
import { EstornarCardComponent } from '../pages/estornar-card/estornar-card.component';
import { EstornarContractCardComponent } from '../pages/estornar-card/estornar-contract-card/estornar-contract-card.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NotificationModalComponent } from './components/notification-modal/notification-modal.component';
import { AuthComponent } from './components/auth/auth.component';
import { MenuComponent } from './components/menu/menu.component';
import { GlobalSubheaderComponent } from './components/global-subheader/global-subheader.component';

@NgModule({
  declarations: [
    HeaderComponent,
    EstornarCardComponent,
    EstornarContractCardComponent,
    NotificationModalComponent,
    AuthComponent,
    MenuComponent,
    GlobalSubheaderComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    MatBadgeModule,
    MatMenuModule
  ],
  exports: [HeaderComponent, GlobalSubheaderComponent]
})
export class CoreModule {}
